require('./mainApp.style.scss');

const mainAppModule = angular.module('com.comtrade.azureCloud.backup.mainApp', []);

mainAppModule.component('mainApp', require('./mainApp.component'));
mainAppModule.component('about', require('./dialogs/about/aboutDialog.component.js'));
mainAppModule.component('protectionSetPicker', require('./dialogs/protectionSetPicker/protectionSetPicker.component'));
mainAppModule.component('wizard', require('./dialogs/wizard/wizard.component'));
mainAppModule.component('servicePrincipal', require('./dialogs/servicePrincipal/servicePrincipal.component'));
mainAppModule.component('sessionExpiration', require('./dialogs/sessionExpiration/sessionExpiration.component'));
mainAppModule.component('saasSubscription', require('./dialogs/saasSubscription/saasSubscription.component'));
mainAppModule.component('userRoles', require('./dialogs/userRoles/userRoles.component'));
mainAppModule.component('userRoleChangeDialog', require('./dialogs/userRoles/userRoleChangeDialog/userRoleChangeDialog.component'));
mainAppModule.component('ecDeploy', require('./dialogs/ecDeploy/ecDeploy.component'));
mainAppModule.component('addNetworkDialog', require('./dialogs/ecDeploy/addNetworkDialog/addNetworkDialog.component'));
mainAppModule.component('restApiExplorer', require('./dialogs/restApiExplorer/restApiExplorer.component'));
mainAppModule.component('newDiskNameDialog', require('./../virtualMachines/dialogs/recoverVm/dialogs/newDiskNameDialog.component'));
mainAppModule.service('protectionSetPickerPersistence', require('./dialogs/protectionSetPicker/protectionSetPicker.persistence.service'));
mainAppModule.service('saasSubscriptionPersistence', require('./dialogs/saasSubscription/saasSubscription.persistence.service'));
mainAppModule.service('ecDeployPersistence', require('./dialogs/ecDeploy/ecDeploy.persistence.service'));


module.exports = mainAppModule;


// WEBPACK FOOTER //
// ./src/azurebackup/views/mainApp/mainApp.module.js